import { Component, ElementRef, Injectable } from '@angular/core';
import { Form, FormGroup, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  private errorCode: string | undefined;
  private errorHeadline: string | undefined;
  private errorSubline: string | undefined;


  ErrorHandlerService(
  ) {
  }



  public validateForm(form: FormGroup): boolean {
    form.markAllAsTouched();
    return form.valid;}

  public scrollToFirstInvalidControl(element: ElementRef): void {
    const firstInvalidControl: HTMLElement = element.nativeElement.querySelector(
      ".ng-invalid"
    );
    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: "smooth"
    });
  }

  private getTopOffset(controlEl: HTMLElement): number{
  const labelOffset = 150;
  return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
}

  public setErrorCode(code: string): void {
    this.errorCode = code;
  }
  public setHeadline(headline: string): void {
    this.errorHeadline = headline;
  }
  public setSubline(subline: string): void {
    this.errorSubline = subline;
  }
  public getErrorCode(): string | undefined {
    return this.errorCode;
  }
  public getHeadline(): string | undefined {
    return this.errorHeadline;
  }
  public getSubline(): string | undefined {
    return this.errorSubline;
  }

  public getErrorMessage(error: ValidationErrors | null | undefined): string {
    if (error) {
      if (error.required) {
        return 'Dieses Feld ist erforderlich';
      } else if (error.email) {
        return 'Bitte geben Sie eine gültige E-Mail-Adresse ein';
      } else if (error.emailDomain) {
        const domains = (error.emailDomain.allowedDomains as string[]).map((domain) => `@${domain}`).join(' oder ');
        return `Bestellungen sind nur mit einer E-Mail-Adresse von ${domains} möglich`;
      } else if (error.minlength) {
        return `Bitte geben Sie mindestens ${error.minlength.requiredLength} Zeichen ein`;
      } else if (error.maxlength) {
        return `Bitte geben Sie maximal ${error.maxlength.requiredLength} Zeichen ein`;
      } else if (error.pattern) {
        return `Bitte geben Sie eine gültige Postleitzahl ein`;
      } else if (error.invalidDate) {
        return `Bitte geben Sie ein gültiges Datum ein`;
      } else if (error.lettersOnly) {
        return `Bitte geben Sie nur <strong>Buchstaben</strong> ein`;
      } else if (error.numericOnly) {
        return `Bitte geben Sie nur <strong>Ziffern</strong> ein`;
      } else if (error.alphanumericWithSpaces) {
        return `Bitte geben Sie nur <strong>Buchstaben</strong> und/oder <strong>Zahlen</strong> ein`;
      } else if (error.volumeSheetFormat) {
        return `Bitte geben Sie zwei <strong>Ziffern</strong> getrennt durch '/' ein`;
      }

      console.log(error);
    }
    return '';
  }
}
